export default __webpack_public_path__ + "dec7d1cadb6f325271aac84121b0618b.png";